import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { StateService } from "../../../core/providers/state/state.service";
import { takeUntil } from "rxjs/operators";
import { NGXLogger } from "ngx-logger";

@Component({
    selector: 'vsf-root-entry-component',
    template: `
      <ng-container *ngIf="(storeIdentifier$ | async)">
        <vsf-general-page></vsf-general-page>
      </ng-container>
    `
})
export class RootEntryComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    storeIdentifier$: Observable<string | null>;

    constructor(private stateService: StateService,
      private logger: NGXLogger,
    ) {}

    ngOnInit() {
        this.logger.debug('RootEntryComponent ngOnInit');
        this.storeIdentifier$ = this.stateService.select(state => state.storeIdentifier)
        .pipe(takeUntil(this.destroy$));
        this.storeIdentifier$.subscribe(storeIdentifier => {
          this.logger.debug(`RootEntryComponent::ngOnInit::storeIdentifier:${storeIdentifier}`);
        });
    }

    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
    }
}